import http from '../services/http';

import {
    GET_ALL_BOOKINGS_ENDPOINT,
    UPDATE_BOOKING_ENDPOINT,
    DELETE_BOOKING_ENDPOINT,
    BOOKING_STATS_ENDPOINT,
    DELETE_TRANSACTION_DELEGATE_ENDPOINT,
    POST_BOOKING_ENROLL_USERS_ENDPOINT,
    GET_BOOKING_COUNTRIES_ENDPOINT,
    GET_BOOKING_COUNTRY_ENDPOINT,
    generateEndpoint
} from '../services/endpoints';

export default (() => {

    function getAll(params) {

        return http.get(GET_ALL_BOOKINGS_ENDPOINT, { params: params });
    }

    function update(booking) {

        const endpoint = generateEndpoint(UPDATE_BOOKING_ENDPOINT, { id: booking.id });

        return http.put(endpoint, booking);
    }

    function remove(bookingId, options) {

        const endpoint = generateEndpoint(DELETE_BOOKING_ENDPOINT, { id: bookingId });

        return http.delete(endpoint, { params: options });
    }

    function deleteDelegate(delegateId) {

        const endpoint = generateEndpoint(DELETE_TRANSACTION_DELEGATE_ENDPOINT, { delegateId });

        return http.delete(endpoint);
    }

    function enrollDelegate(bookingParams) {

        return http.post(POST_BOOKING_ENROLL_USERS_ENDPOINT, bookingParams);
    }

    function getStats() {

        return http.get(BOOKING_STATS_ENDPOINT);
    }

    function getCountries() {

        return http.get(GET_BOOKING_COUNTRIES_ENDPOINT);
    }

    function getCountry(countryId) {

        return http.get(GET_BOOKING_COUNTRY_ENDPOINT+'/'+countryId);
    }

    return {
        getStats,
        getAll,
        update,
        remove,
        deleteDelegate,
        enrollDelegate,
        getCountries,
        getCountry
    };

})();


// WEBPACK FOOTER //
// ./services/bookings.js